

import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop, VModel} from 'vue-property-decorator';
import PazClipboardButton from "@pazion/pazion-core/src/components/controls/PazClipboardButton.vue";
import {getEntityLog} from "@pazion/pazion-core/src/services/base-service";
import {IEntityLog} from "@pazion/pazion-core/src/models/models";
import PazLoader from "@pazion/pazion-core/src/components/utils/PazLoader.vue";
import PazAjaxTable from "@pazion/pazion-core/src/components/layout/PazAjaxTable.vue";
import {DataTableHeader} from "vuetify";
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';
@Component({
  components: {PazAjaxTable, PazLoader, PazClipboardButton, VueJsonPretty}
})
export default class EntityLogDialog extends Vue {

  public dialog: boolean = false;
  loading: boolean = true;

  @Prop({default: 'Entity log'})
  public title!: string;

  public items: IEntityLog[]= [];

  public headers: DataTableHeader<IEntityLog>[] = [
    {text: "When", cellClass: 'nowrap',value:"createdAt" , width: '10%'},
    {text: "message", value:"message" , width: '50%' },
    {text: "details", value:"extra" , width: '40%' },
  ];
  public async showDialog(id: number | string, type: string) {
    this.dialog = true;
    this.loading = true;
    this.items = await getEntityLog(id, type);
    this.loading = false;
  }
  public getJson(item: IEntityLog){
    if(item.extra == null || item.extra.length == 0){
      return '';
    }
    try {
      return JSON.parse(item.extra);
    }
    catch (e){
      return '';
    }
  }
}
